import { useClipboard, useDisclosure } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useSnackbar } from 'ui-components';
import { Button, IButtonProps } from 'ui-components/dist/Button';
import { ShareIcon } from 'ui-components/dist/ShareIcon';
import { ICreator } from '~/types';

import ShareCreatorModal from './ShareCreatorModal';

interface ShareCreatorButtonProps extends IButtonProps {
  creator: ICreator;
}

export const ShareCreatorButton: React.FC<ShareCreatorButtonProps> = ({
  creator,
}) => {
  const snackbar = useSnackbar();
  const { isOpen: openModal, onOpen, onClose } = useDisclosure();

  const { onCopy } = useClipboard(
    `https://${creator.slug}.${process.env.NEXT_PUBLIC_SHARED_PROFILES_HOST}`,
  );

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onCopy();

      snackbar.success({
        isCloseable: false,
        description: 'Link copied',
      });
    },
    [onCopy, snackbar],
  );

  return (
    <>
      <ShareCreatorModal
        creator={creator}
        isOpenModalShareCreator={openModal}
        onClose={onClose}
        handleClick={handleClick}
      />
      <Button
        variant="primary"
        aria-label="Share Creator"
        onClick={onOpen}
        leftIcon={<ShareIcon boxSize={4} />}
        size="sm"
        sx={{
          marginLeft: 3,
        }}
      >
        Share
      </Button>
    </>
  );
};
